module.exports = __webpack_public_path__ + "img/99.8.10cd7abe.png";